import { Content, List, Root, Trigger } from '@radix-ui/react-tabs';
import { forwardRef } from 'react';

import { cn } from 'helpers/classnames';

const Tabs = Root;

const TabsList = forwardRef<React.ElementRef<typeof List>, React.ComponentPropsWithoutRef<typeof List> & { isWrap?: boolean }>(
  ({ className, isWrap = true, ...props }, ref) => {
    const wrapClasses = 'flex-wrap';
    const scrollClasses = 'overflow-x-auto scrollbar-hidden';
    return (
      <List
        ref={ref}
        className={cn('inline-flex w-full items-center gap-x-2 gap-y-3', isWrap ? wrapClasses : scrollClasses, className)}
        {...props}
      />
    );
  }
);
TabsList.displayName = List.displayName;

const TabsTrigger = forwardRef<React.ElementRef<typeof Trigger>, React.ComponentPropsWithoutRef<typeof Trigger>>(({ className, ...props }, ref) => (
  <Trigger
    ref={ref}
    className={cn(
      'flex items-center gap-x-1 whitespace-nowrap text-base underline underline-offset-4 transition-all data-[state=active]:no-underline zappos:data-[state=active]:font-semibold',
      'zappos:body-m zappos:hover:decoration-2',
      className
    )}
    {...props}
  />
));
TabsTrigger.displayName = Trigger.displayName;

const TabsContent = forwardRef<React.ElementRef<typeof Content>, React.ComponentPropsWithoutRef<typeof Content>>(({ className, ...props }, ref) => (
  <Content
    ref={ref}
    className={cn(
      'flex-col flex-wrap gap-y-4 rounded-2xl p-0 transition-all data-[state=active]:flex sm:border sm:border-subtle sm:px-5 sm:py-4',
      className
    )}
    {...props}
  />
));
TabsContent.displayName = Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
